export default __webpack_public_path__ + "static/media/reports-i.77fafe09.svg";